import { Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Directive({
	standalone: true,
	selector: '[panel]'
})
export class PanelDirective {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() isOpen: boolean;

	private isSection: boolean = false;

	constructor(private el: ElementRef, private renderer: Renderer2) {

	}
	
	ngOnInit() {
		const element = this.el.nativeElement;
		this.isSection = !!element.querySelector('.c-section__header');
		const openClass = this.isSection ? 'c-section--open' : 'c-panel--open';

		if (this.isOpen) {
			this.renderer.addClass(element, openClass);
		}

		this.angularHelperService.createTimer(() => {
			const header = element.querySelector('.c-section__header') || element.querySelector('.c-panel__header');
			if (header) {
				this.renderer.listen(header, 'click', () => {
					this.isOpen = !this.isOpen;
					this.toggle(this.isOpen);
				});
			}
		});
	}

	ngOnChanges() {
		this.toggle(this.isOpen);
	}
	
	toggle(toOpen: boolean): void {
		const element = this.el.nativeElement;
		if (toOpen) {
			this.expand(element);
		} else {
			this.collapse(element);
		}
	}

	collapse(panel: HTMLElement): void {
		const content = this.isSection ? panel.querySelector('.c-section__content') : panel.querySelector('.c-panel__content');
		if (content) {			
			const openClass = this.isSection ? 'c-section--open' : 'c-panel--open';
			const contentHeight = content.scrollHeight;
	
			this.renderer.setStyle(content, 'height', `${contentHeight}px`);
			requestAnimationFrame(() => {
				this.renderer.setStyle(content, 'height', '0px');
				requestAnimationFrame(() => {
					this.renderer.setStyle(content, 'height', null);
					this.renderer.removeClass(panel, openClass);
				});
			});
		}
	}

	expand(panel: HTMLElement): void {
		const content = this.isSection ? panel.querySelector('.c-section__content') : panel.querySelector('.c-panel__content');
		if (content) {
			const openClass = this.isSection ? 'c-section--open' : 'c-panel--open';
			const contentHeight = content.scrollHeight;
	
			if (!content.getBoundingClientRect().height) {
				this.renderer.setStyle(content, 'height', `${contentHeight}px`);
			}
			this.renderer.addClass(panel, openClass);
	
			this.renderer.listen(content, 'transitionend', () => {
				this.renderer.setStyle(content, 'height', null);
			});
		}
	}
}